<template>
    <div>
        <b-modal
            id="confirm_redeem_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <!-- <div class="modal-base-head">
                    <div id="headline" v-html="headline"></div>
                </div> -->
                <div class="modal-base-body">
                    <p id="message" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-secondary btn-cancel" @click="clickCloseConfirmRedeem()">{{lblConfirmRedeem.cancel}}</button>
                    <button class="btn btn-primary btn-confirm" @click="clickConfirmRedeem()">{{lblConfirmRedeem.confirm}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: 'ConfirmRedeemModal',
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            message: '',

            lblConfirmRedeem: {},
            lblDate: {},
            tracking: new TrackingService(this),
        };
    },
    mounted: function () {
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.busModal.$on('showConfirmRedeemModal', this.initialConfirmModal);
        this.busModal.$on('hideConfirmRedeemModal', this.closeConfirmModal);
    },
    methods: {
        //Event
        clickConfirmRedeem: function () {
            
            this.tracking.event("campaign_detail", "click_confirm_redeem_campaign");
            this.$emit('clickConfirmRedeem');
            this.closeConfirmModal();
        },
        clickCloseConfirmRedeem: function () {
            
            this.tracking.event("campaign_detail", "click_unconfirm_redeem_campaign");
            this.closeConfirmModal();
        },
        //Function
        initialConfirmModal: function () {
           console.log("redeemconfirm");
            var minute = this.campaign.minutesValidAfterUsed;
            var isDelivered = false;
            var haveTimer = false;

            if(this.campaign.delivered) isDelivered = true;
            if(this.campaign.minutesValidAfterUsed
                || this.campaign.minutesValidAfterUsed > 0) haveTimer = true;

            this.headline = this.lblConfirmRedeem.headline;
            
            switch(this.campaign.type) {
                case Vue.CampaignType.Draw:
                    this.message = isDelivered
                        ? this.lblConfirmRedeem.draw_delivery
                        : this.getDrawMessage(this.lblConfirmRedeem.draw);
                    break;
                case Vue.CampaignType.Free:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.free_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.free_no_timer + " " + this.campaign.name;
                    }
                    break;
                case Vue.CampaignType.Deal:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.deal_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.deal_no_timer + " " + this.campaign.name;
                    }
                    break;
                case Vue.CampaignType.Buy:
                    this.message = this.lblConfirmRedeem.buy;
                    break;
                case Vue.CampaignType.Interface:
                    this.message = this.lblConfirmRedeem.interface;
                    break;
                default:
                    break;
            }

            this.message = this.lblConfirmRedeem.headline
            this.$bvModal.show('confirm_redeem_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('confirm_redeem_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>

<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-size: 1.1rem;
        text-decoration: underline;
    }

    #message {
        text-align: center;
        margin: 30px;
        font-size: 1rem;
    }

    .btn-cancel {
        width: calc(50% - 7.5px);
        border: 2px solid #000;
        background-color: white;
        color:black;
        border-radius: 0;
        font-size: 1rem;
    }

    .btn-confirm {
        margin-left: 10px;
        width: calc(50% - 7.5px);
        border: 2px solid #000;
        background-color: black;
        color:white;
        border-radius: 0;
        font-size: 1rem;
    }
</style>
